import { Box, Button } from "@mui/material";
import React from "react";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Flex from "../../../../../../../../components/Flex";
import Input from "../../../../../../../../components/Input";
import { DropDownOptions } from "./DynamicForm";

interface FormFieldProps {
  question: string;
  idx: number;
  value: string | null;
  onChange: (value: string | null) => void;
  noteValue?: string;
  onNoteChange?: (id: number, value: string | undefined) => void;
  questionType: string;
  dropDownOptions?: DropDownOptions[];
}

const FormField: React.FC<FormFieldProps> = ({
  question,
  idx,
  value,
  onChange,
  // noteValue,
  // onNoteChange,
  questionType,
  dropDownOptions,
}) => {
  const renderInput = (
    questionType: string,
    dropDownOptions?: DropDownOptions[]
  ) => {
    switch (questionType) {
      case "TEXT":
        return (
          <Box
            sx={{
              width: "100%",
              mt: 2,
            }}
          >
            <Input
              label="Enter Value"
              textFieldProps={{
                name: "InputFiled",
                value: value,
                onChange: (e) => onChange(e.target.value),
                placeholder: "Enter Value",
              }}
            />
          </Box>
        );
      case "STRING":
        return (
          <Box
            sx={{
              width: "220px",
              height: "34px",
            }}
          >
            <CustomSelect
              value={value}
              placeholder="Select"
              onChange={(val) => onChange(val)}
              options={dropDownOptions?.map((s) => {
                return {
                  value: s.answer,
                  label: s.answer,
                };
              })}
            />
          </Box>
        );
      case "BOOLEAN":
        return (
          <Flex gap={2} mt={1}>
            {["true", "false"].map((opt, i) => (
              <Button
                key={i}
                type="button"
                variant={value === opt ? "contained" : "outlined"}
                onClick={() => onChange(opt)}
                sx={{ fontSize: "12px" }}
              >
                {opt === "true" ? "Yes" : opt === "false" ? "No" : "-"}
              </Button>
            ))}
          </Flex>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <label className="font-medium block" style={{ fontSize: "12px" }}>
        {idx + 1}. {question}
      </label>
      <div style={{ marginTop: "8px" }}>
        {renderInput(questionType, dropDownOptions)}
      </div>

      {/* <Button
        type="button"
        onClick={() => onNoteChange(id, noteValue ? undefined : "")}
        className="text-blue-600 mt-2 text-sm flex items-center"
      >
        <span className="mr-1">➕</span> Note
      </Button>

      {noteValue !== undefined && (
        <Input
          // style: "mt-2 w-full border p-2 text-sm",
          textFieldProps={{
            placeholder: "Enter note...",
            value: noteValue,
            onChange: (e) => onNoteChange(id, e.target.value),
          }}
        />
      )} */}
    </Box>
  );
};

export default FormField;
